import { type SerializedCompStructure } from '@wix/document-services-types'
import {
  type DataBindingConnectionConfigByRole,
  type DataBindingRole,
} from '../types'
import {
  applyModifiers,
  setComponentConnectionConfigs,
  setComponentVeloId,
} from '../utils'

export const adjustComponent = ({
  component,
  modifyComponent,
  connectionConfigByRole,
  veloId,
}: {
  component: SerializedCompStructure
  modifyComponent?: (
    component: SerializedCompStructure,
  ) => SerializedCompStructure
  connectionConfigByRole?: {
    [Role in DataBindingRole]?: DataBindingConnectionConfigByRole[Role]
  }
  veloId: string
}) =>
  applyModifiers({
    target: component,
    modifiers: {
      modifyComponent,

      configureConnections:
        connectionConfigByRole !== undefined
          ? (component: SerializedCompStructure) =>
              setComponentConnectionConfigs({
                component,
                configByRole: connectionConfigByRole,
              })
          : undefined,

      setVeloId: component => setComponentVeloId({ component, veloId }),
    },
  })
